<template>
  <div class="layout">
    <div class="layout-header">
      <slot name="header"></slot>
      <slot name="navigation"></slot>
    </div>

    <div class="layout-content">
      <slot></slot>
    </div>

    <div class="layout-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>
<style>
.layout {
  position: relative;
  height: 100%;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}
.layout > .q-tabs {
  border-radius: 0 !important;
}
.layout-header {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
.layout-footer {
  box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -3px 6px rgba(0,0,0,0.23);
}
.layout-content {
  height: 100%;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  overflow: hidden;
  position: relative;
}
.layout-view {
  overflow: auto;
  position: relative;
  height: 100%;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}
.layout-header,
.layout-footer {
  color: #fff;
  z-index: 10;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.layout-padding {
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .layout-padding {
    padding: 1.5rem 0.5rem;
  }
  .layout-padding.horizontal {
    padding: 0 0.5rem;
  }
}
@media only screen and (min-width: 601px) and (max-width: 920px) {
  .layout-padding {
    padding: 1.5rem 2rem;
    margin: auto;
  }
  .layout-padding.horizontal {
    padding: 0 2rem;
  }
}
@media only screen and (min-width: 921px) and (max-width: 1280px) {
  .layout-padding {
    padding: 2.5rem 3rem;
    margin: auto;
  }
  .layout-padding.horizontal {
    padding: 0 3rem;
  }
}
@media only screen and (min-width: 1281px) {
  .layout-padding {
    padding: 3rem 4rem;
    margin: auto;
  }
  .layout-padding.horizontal {
    padding: 0 4rem;
  }
}
</style>
